import Vue from "vue";
import firebaseApp from "@/main";
import Vuex, { GetterTree, MutationTree, ActionTree } from "vuex";
Vue.use(Vuex);

// *** Interface imports
import {
  ChangeWorkoutHistory,
  WorkoutHistoryDateRanges,
} from "@/interfaces/history.interface";
import { Workout } from "@/interfaces/workout.interface";

class State {
  workoutHistory: Workout[] = [];
}

const getters = <GetterTree<State, any>>{
  getWorkoutHistory(state): Workout[] {
    return state.workoutHistory;
  },
  getDateRange(state): WorkoutHistoryDateRanges {
    const currentWorkoutHistory: Workout[] = state.workoutHistory;
    const dateRange: WorkoutHistoryDateRanges = {
      oldDate: null,
      recentDate: null,
    };
    if (currentWorkoutHistory.length != 0) {
      dateRange.recentDate = currentWorkoutHistory[0].startTime;
      const potentialOldDate: number | undefined =
        currentWorkoutHistory[currentWorkoutHistory.length - 1].endTime;
      if (potentialOldDate) dateRange.oldDate = potentialOldDate;
    }
    return dateRange;
  },
};

const mutations = <MutationTree<State>>{
  addWorkoutToHistory(state, newWorkout: Workout) {
    state.workoutHistory.unshift(newWorkout);
  },
  updateWorkoutHistory(state, newWorkouts: Workout[]) {
    const currentWorkouts = state.workoutHistory;
    const allWorkouts: Workout[] = currentWorkouts.concat(newWorkouts);
    const uniqueWorkouts: Workout[] = [];

    // Removes Duplicates
    allWorkouts.forEach((workout) => {
      let isDuplicate = false;
      uniqueWorkouts.forEach((nonDupe) => {
        if (nonDupe.startTime === workout.startTime) isDuplicate = true;
      });
      if (!isDuplicate) uniqueWorkouts.push(workout);
    });

    uniqueWorkouts.sort((a, b) => {
      return b.startTime - a.startTime;
    });

    state.workoutHistory = uniqueWorkouts;
  },
  removeWorkout(state, workoutToDelete: Workout) {
    let idxToDelete = -1;
    state.workoutHistory.forEach((workout, workoutIdx) => {
      if (workout.startTime === workoutToDelete.startTime)
        idxToDelete = workoutIdx;
    });
    if (idxToDelete !== -1) {
      state.workoutHistory.splice(idxToDelete, 1);
    }
  },
  changeHistoryWorkout(state, payload: ChangeWorkoutHistory) {
    state.workoutHistory.forEach((workout) => {
      if (workout.startTime === payload.startTime) {
        workout = payload.newHistoryCard;
      }
    });
  },
};

const actions = <ActionTree<State, any>>{
  async getWorkoutHistory(
    { rootGetters },
    dateRanges: WorkoutHistoryDateRanges
  ): Promise<Workout[]> {
    const myUID: string | null = rootGetters["userStore/getUserUID"];
    if (myUID) {
      let suc = true;

      const userWorkoutRef = firebaseApp
        .firestore()
        .collection("users")
        .doc(myUID)
        .collection("workouts");
      const workouts: Workout[] = [];

      await userWorkoutRef
        .where("startTime", ">", dateRanges.oldDate)
        .where("startTime", "<", dateRanges.recentDate)
        .get()
        .then((workoutDocuments) => {
          // todo: change any to a valid type
          workoutDocuments.docs.forEach((workoutDoc: any) => {
            const workoutData: Workout = workoutDoc.data();
            workoutData.showExtraDetails = false;
            workouts.push(workoutData);
          });
        })
        .catch((err) => {
          console.error(err);
          suc = false;
        });

      if (suc) return Promise.resolve(workouts);
      else return Promise.reject("Could not get date range :(");
    } else return Promise.reject("User Is Not Signed In.");
  },
};

const historyStore = {
  namespace: true,
  state: new State(),
  getters: getters,
  mutations: mutations,
  actions: actions,
};

export default historyStore;
